import { render, staticRenderFns } from "./RecurringFeeSetup.vue?vue&type=template&id=1860053e&"
import script from "./RecurringFeeSetup.vue?vue&type=script&lang=js&"
export * from "./RecurringFeeSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports